var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.library.logo_url != null)?_c('b-img-lazy',{staticClass:"rounded-circle p-2",style:(_vm.imgStyle),attrs:{"src":this.logoUrl()}}):_c('NameCircle',{staticClass:"p-2",attrs:{"name":_vm.library.name,"size":this.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }